import cn from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import styles, {
  LayoutShellStyleProps,
} from 'src/component-layout/LayoutPage/LayoutPage.style'
import Subnav, {
  SubnavDesign,
  SubnavOption,
} from 'src/components/Subnav/Subnav'
import { selectIsSidenavLockedOpenFromState } from 'src/redux/selectors/app.selectors'
import { selectFixedElementPushdown } from 'src/redux/selectors/css.selectors'
import styled from 'styled-components'

export interface LayoutPageProps extends React.PropsWithChildren {
  background?: 'white' | 'gray'
  padding?: 'small' | 'medium' | 'none'
  addRightShift?: boolean
  fixedHeight?: boolean
  title?: React.ReactElement
  subtitle?: React.ReactNode
  actions?: React.ReactElement
  className?: string
  subnavOptions?: SubnavOption[]
}

const StyledLayoutPageWrapper = styled.div<LayoutShellStyleProps>`
  ${styles}
`

const LayoutPage: React.FC<LayoutPageProps> = ({
  background = 'gray',
  padding = 'small',
  addRightShift = true,
  fixedHeight = false,
  title,
  subtitle,
  actions,
  children,
  className,
  subnavOptions = [],
}) => {
  const fixedElementPushdown = useSelector(selectFixedElementPushdown)
  const sideNavLockedOpen = useSelector(selectIsSidenavLockedOpenFromState)
  const rightShift = sideNavLockedOpen ? '208px' : '40px'

  return (
    <StyledLayoutPageWrapper
      className={cn('LayoutPage', className, background, padding, {
        'with-subnav': subnavOptions.length > 0,
        'fixed-height': fixedHeight,
      })}
      fixedElementPushdown={fixedElementPushdown}
      rightShift={addRightShift ? rightShift : '0px'}
    >
      {(title || actions) && (
        <div className="header">
          <div className="title-section">
            <span className="font-h2">{title}</span>
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </div>
          {actions && <div className="actions">{actions}</div>}
        </div>
      )}
      <div className="flex-column gap-3 h-full">
        {subnavOptions.length > 0 && (
          <Subnav options={subnavOptions} design={SubnavDesign.Floating} />
        )}
        {children && <div className="content">{children}</div>}
      </div>
    </StyledLayoutPageWrapper>
  )
}

export default LayoutPage
